import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';

import { fetchContactServiceRequests } from '../../store/actions/contacts';
import { selectContactServiceRequests } from '../../store/selectors/contacts';
import ServiceRequestsTable from '../../components/ServiceRequestsTable/ServiceRequestsTable_legacy';
import { setSearch, clearSearch }  from '../../store/actions/search';
import { fetchServiceRequests, clearServiceRequests, fetchServiceRequestsListByUser } from '../../store/actions/serviceRequests';

import { PATHS } from '../../common/constants';
import { selectLoader } from '../../store/selectors/loader';
import Loader from '../../components/Loader';
import { fetchContactServiceRequestCSVExportDownloadList } from '../../store/actions/csvExport';
import { selectAuthenticatedUser } from '../../store/selectors/auth';

class ContactServiceRequests extends Component {
  state = {
    searchString: ''
  }
  componentDidMount() {
    const { contact, onFetchContactServiceRequests, clearSearch ,onFetchServiceRequestsListByUser,user} = this.props;
    // onFetchContactServiceRequests(contact.id);
    if(user.roles[0].role.name === 'Admin' || user.roles[0].role.name === 'Super Admin' || user.roles[0].role.name === 'Property Developer' || user.roles[0].role.name === 'Strata Manager'){
      onFetchServiceRequestsListByUser(contact.id,contact.roles[0].role.name, 1, '')
    }else{
      onFetchServiceRequestsListByUser(user.id,user.roles[0].role.name, 1, '')
    }
    
    clearSearch();
  }

  loadMoreServiceRequest = async () => {
    const { onFetchServiceRequestsListByUser, paginationCount, contact } = this.props;
    onFetchServiceRequestsListByUser(contact.id,contact.roles[0].role.name, paginationCount+1, this.state.searchString)
  }
  search = async (text) => {
    this.setState({ searchString: text})
    const { contact, onFetchServiceRequestsListByUser } = this.props;
   
    onFetchServiceRequestsListByUser(contact.id,contact.roles[0].role.name, 1, text, true)
  }

  downloadCSV(){
    const { fetchContactServiceRequestCSVExportDownloadList,user,contact } = this.props;
    fetchContactServiceRequestCSVExportDownloadList(contact.id,contact.roles[0].role.name, this.state.searchString);
  }

  render() {
    const { contact, contactServiceRequests, onFetchContactServiceRequests, setSearch, loader } = this.props;
    
    return (
      loader ? <Loader /> :
      <ServiceRequestsTable
        download= {() => this.downloadCSV()}
        serviceRequests={contactServiceRequests}
        // onSearch={e => setSearch({ serviceRequests: e.target.value.trim()})}
        onSearch = {e => this.search(e.target.value.trim())}
        loadServiceRequest = {this.loadMoreServiceRequest}
        from='Contact'
        navigateTo={PATHS.CONTACTS_VIEW.replace(':id', contact.id)}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user:selectAuthenticatedUser(state),
  paginationCount: state.paginationCount.count,
  pageCount: state.serviceRequestStatusPageCount.pageCount,
  contactServiceRequests: selectContactServiceRequests(state, ownProps.contact.id),
  loader: selectLoader(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchContactServiceRequests: fetchContactServiceRequests,
  onFetchServiceRequestsListByUser:fetchServiceRequestsListByUser,
  
  setSearch,
  clearSearch,
  fetchContactServiceRequestCSVExportDownloadList:fetchContactServiceRequestCSVExportDownloadList
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ContactServiceRequests);
